import { Component, input } from '@angular/core';
import { CustomFieldCompositionDto } from '@artemis-software/wr-api';
import { CustomFieldFormElement } from '@shared/custom-form/custom-form/custom-form.component';
import { AbstractControl, FormArray, FormControl } from '@angular/forms';
import { format, parseISO } from 'date-fns';
import { TableConfig, getTableConfig } from '@shared/custom-form/table-config';
import { displayUnitSymbol } from '@shared/pipes/unit-symbols';

@Component({
  standalone: false,
  selector: 'wr-custom-form-element',
  templateUrl: './custom-form-element.component.html',
  styleUrls: ['./custom-form-element.component.scss'],
})
export class CustomFormElementComponent {
  readonly formElement = input<CustomFieldFormElement>();

  get isMultiControl(): boolean {
    return this.formElement()?.field.composition.cardinalityType === CustomFieldCompositionDto.CardinalityTypeEnum.Multiple;
  }

  get formArray(): FormArray | undefined {
    return this.formElement()?.formControl as FormArray | undefined;
  }

  asFormControl(control: AbstractControl): FormControl {
    return control as FormControl;
  }

  private readonly _dateCache = new Map<string, Date>();

  parseLocalDate(value: string | null | undefined): Date | null {
    if (!value) return null;
    if (!this._dateCache.has(value)) {
      try {
        this._dateCache.set(value, parseISO(value));
      } catch {
        return null;
      }
    }
    return this._dateCache.get(value) ?? null;
  }

  onLocalDateChange(control: AbstractControl, date: Date | null): void {
    control.setValue(date ? format(date, 'yyyy-MM-dd') : null);
    control.markAsDirty();
  }

  onLocalDateTimeChange(control: AbstractControl, date: Date | null): void {
    control.setValue(date ? format(date, "yyyy-MM-dd'T'HH:mm:ss") : null);
    control.markAsDirty();
  }

  readonly ValueTypeEnum = CustomFieldCompositionDto.ValueTypeEnum;

  readonly displayUnit = displayUnitSymbol;

  getTableConfig(composition: CustomFieldCompositionDto): TableConfig | null {
    return getTableConfig(composition);
  }
}
